import React from "react";
import RenderDropDownsLogic from "./renderDropDownsLogic";

type complementaryDropDownProps = { control; errors; setValue; getValues };
const RendercomplementaryDropDown = ({
  control,
  errors,
  setValue,
  getValues,
}: complementaryDropDownProps) => {
  return (
    <RenderDropDownsLogic
      control={control}
      errors={errors}
      setValue={setValue}
      getValues={getValues}
    />
  );
};

export default RendercomplementaryDropDown;
